import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { showNotification } from "@mantine/notifications";
import { customAxios } from "lib/axios";

export interface UserRef {
  _id: string;
  email?: string;
}

export interface LeaveRequest {
  _id: string;
  user: UserRef;
  org?: string;
  department?: string;
  leaveType?: string;
  reason?: string;
  fromDate?: string;
  toDate?: string;
  numberOfDays?: number;
  status?: string;
  approvals?: any[];
  flaggedToDirector?: boolean;
  isOverride?: boolean;
  createdBy?: string;
  createdAt?: string;
  updatedAt?: string;
  __v?: number;
}

export type LeaveRequestsResponse = {
  success: boolean;
  count: number;
  total: number;
  page?: number;
  limit?: number;
  totalPages: number;
  data: LeaveRequest[];
};

export type GetAdminLeavesOpts = {
  status?: string;
  year?: number;
  departmentId?: string;
  page?: number;
  limit?: number;
};

const fetchLeaveRequestsAdmin = async (opts?: GetAdminLeavesOpts) => {
  const params: Record<string, unknown> = {};
  if (
    opts?.status !== undefined &&
    opts?.status !== null &&
    opts?.status !== ""
  ) {
    params.status = opts.status;
  }
  if (opts?.year !== undefined && opts?.year !== null) {
    params.year = opts.year;
  }
  if (
    opts?.departmentId !== undefined &&
    opts?.departmentId !== null &&
    opts?.departmentId !== ""
  ) {
    params.departmentId = opts.departmentId;
  }
  if (opts?.page !== undefined && opts?.page !== null) {
    params.page = opts.page;
  }
  if (opts?.limit !== undefined && opts?.limit !== null) {
    params.limit = opts.limit;
  }

  const res = await customAxios.get<LeaveRequestsResponse>(
    "/leaves/all-requests",
    {
      params,
    },
  );
  return res.data;
};

export const useGetLeaveRequestsAdmin = (opts?: GetAdminLeavesOpts) =>
  useQuery<LeaveRequestsResponse, AxiosError>(
    [
      "leaveRequestsAdmin",
      opts?.status ?? null,
      opts?.year ?? null,
      opts?.departmentId ?? null,
      opts?.page ?? 1,
      opts?.limit ?? "all",
    ],
    () => fetchLeaveRequestsAdmin(opts),
    {
      onError: (error) =>
        showNotification({
          title: "Error Loading Leave Requests",
          message:
            (error.response?.data as { message?: string })?.message ??
            "Failed to load leave requests",
          color: "red",
        }),
      staleTime: 0,
      retry: 1,
      refetchOnMount: "always",
    },
  );
